export default [{"id":"1","startTime":0,"endTime":4523,"text":"<b>Feel free to twist all the way round and admire</b>\n<b>the grounds from every angle.</b>"}];